{
  "name": "cloud-3ddrawing-app",
  "version": "1.9.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build:dev": "ng build --c=development",
    "build:qa": "ng build --c=qa",
    "build:prod": "ng build --c=production",
    "build:prod-release": "ng build --c=production",
    "watch": "ng build --watch --configuration development",
    "test": "ng test"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^22.2.0",
    "@angular/common": "^22.2.0",
    "@angular/compiler": "^22.2.0",
    "@angular/core": "^22.2.0",
    "@angular/forms": "^22.2.0",
    "@angular/platform-browser": "^22.2.0",
    "@angular/platform-browser-dynamic": "^22.2.0",
    "@angular/router": "^22.2.0",
    "crypto": "^1.0.1",
    "jquery": "^4.0.0",
    "nextnavsdk": "file:nextnavsdk-2.3.2.tgz",
    "nextnavsdknew": "file:nextnavsdknew-2.3.3.tgz",
    "pubnub": "^11.0.1",
    "rxjs": "~7.8.2",
    "tslib": "^2.8.1",
    "zone.js": "~0.16.2"
  },
  "devDependencies": {
    "@angular/build": "^22.2.0",
    "@angular/cli": "~22.2.0",
    "@angular/compiler-cli": "^22.2.0",
    "@types/crypto-js": "^4.2.2",
    "@types/jasmine": "~6.0.0",
    "@types/node": "^25.9.1",
    "@types/pubnub": "^8.2.8",
    "istanbul-lib-instrument": "^6.0.3",
    "jasmine-core": "~6.2.0",
    "karma": "~6.4.4",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.1",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.2.0",
    "typescript": "^6.0.3"
  }
}
